import { Controller } from "@hotwired/stimulus";
import $ from 'jquery';

export default class extends Controller {
  static targets = ['extrasContainer', 'wifiPrice', 'batteryPrice', 'batteryPriceContainer', 'totalPrice']

  connect() {
    $(this.element).on(`recalculatePrice`, this.updatePrice.bind(this))
  }

  updatePrice(_e, data) {
    this.wifiPriceFormatted = data.wifi_price
    this.wifiBatteryPriceFormatted = data.battery_price
    this.totalPriceFormatted = data.total_price

    this.updateWifiSection();
    this.updateWifiPriceContainer();
    this.updateBatteryPriceContainer();
    this.updateTotalPrice();
  }

  updateWifiSection() {
    if (!this.hasExtrasContainerTarget) { return };

    const shouldShow = !!this.wifiPriceFormatted;
    this.extrasContainerTargets.forEach(container => {
      container.classList.toggle('collapse', !shouldShow);
    });
  }

  updateWifiPriceContainer() {
    if (!this.hasWifiPriceTarget) { return };

    const wifiPrice = this.wifiPriceFormatted || '';
    this.wifiPriceTargets.forEach(wifiPriceTarget => {
      wifiPriceTarget.innerHTML = wifiPrice;
    });
  }

  updateBatteryPriceContainer() {
    if (!this.hasBatteryPriceTarget) { return };

    if (this.wifiBatteryPriceFormatted) {
      if (this.hasBatteryPriceContainerTarget) { this.batteryPriceContainerTarget.hidden = false };
      this.batteryPriceTarget.innerHTML = this.wifiBatteryPriceFormatted;
    } else {
      if (this.hasBatteryPriceContainerTarget) { this.batteryPriceContainerTarget.hidden = true };
      this.batteryPriceTarget.innerHTML = '';
    }
  }

  updateTotalPrice() {
    if (!this.hasTotalPriceTarget) { return };

    this.totalPriceTarget.innerHTML = this.totalPriceFormatted;
  }
}
